import {KpiType} from '@hconnect/common/types'
import {CardBox} from '@hconnect/uikit'
import {Moment} from 'moment-timezone'

import {KpiYearMonthCommentsContainer} from './KpiYearMonthCommentsContainer'

type Props = {
  plantId: string
  selectedDate: Moment
  selectedCommentsKpiTypes: KpiType[]
  onSelectedCommentsKpiTypesChange: (kpiTypes: KpiType[]) => void
}

export const PerformanceReviewCommentsContainer = ({
  plantId,
  selectedDate,
  selectedCommentsKpiTypes,
  onSelectedCommentsKpiTypesChange
}: Props) => {
  return (
    <CardBox>
      <KpiYearMonthCommentsContainer
        plantId={plantId}
        selectedDate={selectedDate}
        selectedCommentsKpiTypes={selectedCommentsKpiTypes}
        onSelectedCommentsKpiTypesChange={onSelectedCommentsKpiTypesChange}
      />
    </CardBox>
  )
}
